<template>
    <div>
        <v-menu
        v-model="openNotificacoes"
        offset-y
        :close-on-content-click="false"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            depressed
            x-small
            class="ui-btn-inherit mr-3"
            v-bind="attrs"
            v-on="on"
            @click="openCloseNotificacoes()"
            >
            <v-icon class="theme--dark menu__toggleicon">notifications_none</v-icon>
            <v-badge
                class="ui-menu-badge"
                :content="notificacoes"
                :value="notificacoes"
                left
                color="red"
            >
            </v-badge>
            </v-btn>
        </template>
        <v-list class="notificacoes_menu pb-0" min-width="430">
          <div class="ml-2 mr-2 text-h2 text-center pb-2">
            Notificações
          </div>
          <ul class="pl-0" style="overflow: auto; max-height: 70vh">
            <v-skeleton-loader v-if="loadingNotificacoes" type="list-item-two-line"></v-skeleton-loader>
            <li
              v-for="(item, index) in notificacoesList.slice(0, max)"
              :key="index"
              v-show="!loadingNotificacoes && notificacoesList.length > 0"
              :class="!item.not_lida ? 'nao_lida' : ''"
            >
                <div
                v-ripple="{ class: `success--text` }"
                class="cursor-pointer px-2 py-2"
                @click="marcaLida(item.uuid_not_id)"
                >
                <v-row align="center" no-gutters>
                    <div class="row_right">
                    <div class="ui-break-word text-primary text" v-html="item.not_descricao">
                    </div>
                    <label class="text text--thin text-small">
                        {{moment(item.not_criado_em).fromNow()}}
                    </label>
                    </div>
                    <div class="row_left">
                      <v-icon @click="marcaLida(item.uuid_not_id)">close</v-icon>
                    </div>
                </v-row>
                </div>
            </li>
            <div class="text-center text text-primary text--thin pa-3" v-if="!loadingNotificacoes && notificacoesList.length == 0">
              Nenhuma notificação encontrada
              <v-icon class="size-nothing" color="primary">sentiment_dissatisfied</v-icon>
            </div>
            </ul>
            <div class="notificacoes_menu__all" v-if="notificacoesList.length > max">
              <v-row no-gutters class="py-2" align="center" justify="center" style="position: relative">
                <v-btn
                  rounded
                  class="ui-btn-clean-free py-1 mr-2"
                  color="primary"
                  @click="max+=4"
                  >
                  Ver mais notificações
                </v-btn>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="positiona_icone" @click="dialogConfirma = true" v-bind="attrs" v-on="on" color="primary">check</v-icon>
                  </template>
                  <span>Marcar todas como lido</span>
                </v-tooltip>
              </v-row>
            </div>
        </v-list>
        </v-menu>
        <v-dialog v-model="dialogConfirma" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Marcar como lido
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogConfirma = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja marcar como lido todas as notificações?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="loadingNotificacoes"
            :loading="loadingNotificacoes"
            @click="dialogConfirma = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="loadingNotificacoes"
            :loading="loadingNotificacoes"
            @click="limparNotificacoes()"
          >
            Continuar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import Api from '@API'
import moment from 'moment'
export default {
  data () {
    return {
      loadingNotificacoes: false,
      clickNotificar: true,
      loadingLida: false,
      radio: true,
      dialogConfirma: false,
      openNotificacoes: false,
      notificacoesList: [],
      notificacoes: 0,
      max: 5
    }
  },
  created () {
    this.buscaNotificacoes()
    setInterval(() => {
      this.buscaNotificacoes()
    }, 900000)
  },
  methods: {
    moment,
    openCloseNotificacoes () {
      this.openNotificacoes = !this.openNotificacoes
    },
    async buscaNotificacoes () {
      this.loadingNotificacoes = true
      await Api.get('notificacoes')
        .then(res => {
          this.loadingNotificacoes = false
          this.notificacoesList = res.data
          this.contarNotificacoes()
        })
        .catch(err => {
          this.loadingNotificacoes = false
          console.log(err)
        })
    },
    contarNotificacoes () {
      if (this.notificacoesList) {
        this.notificacoes = this.notificacoesList.not_status
      } else {
        this.notificacoes = 0
      }
      let qtd = 0
      this.notificacoesList.forEach(value => {
        if (value.not_status === 0) {
          qtd++
        }
      })
      var self = this
      self.notificacoes = qtd
    },
    async limparNotificacoes () {
      this.loadingNotificacoes = true
      await Api.post('notificacoes/marca-todas-lida')
        .then(res => {
          this.dialogConfirma = false
          this.buscaNotificacoes()
        })
        .catch(err => {
          this.loadingNotificacoes = false
          console.log(err)
        })
    },
    marcaLida (uuid) {
      this.loadingNotificacoes = true
      Api.post('notificacoes/marca-lida/' + uuid)
        .then(res => {
          // this.openNotificacoes = !this.openNotificacoes
          this.loadingNotificacoes = false
          this.buscaNotificacoes()
        })
        .catch(err => {
          this.loadingNotificacoes = false
          console.log(err)
        })
    }
  }
}
</script>

  <style scoped lang="scss">
  @import "@scss/_variables.scss";
  @import "@scss/_ui.scss";

  .nao_lida{
    background-color:#0540741f !important;
  }
  .row_left {
    height: 45px;
    padding-left: 10px;
    padding-top: 10px;
    width: 50px;
    >>> .v-input--selection-controls {
      margin-top: 8px!important;
    }
    .disabled_green {
      >>> .v-icon {
        color: $primary !important;
      }
    }
  }
  .row_right {
    width: calc(100% - 50px);
  }
  .positiona_icone {
    position: absolute;
    right: 25px;
  }
  </style>



// WEBPACK FOOTER //
// src/pages/Notificacao.vue